import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from '../utils/translations/en/translation.json'
import translationFR from '../utils/translations/fr/translation.json'
import errorsEN from '../utils/translations/en/errors.json'
import errorsFR from '../utils/translations/fr/errors.json'
import titlesEN from '../utils/translations/en/titles.json'
import titlesFR from '../utils/translations/fr/titles.json'
import textEN from '../utils/translations/en/text.json'
import textFR from '../utils/translations/fr/text.json'
import messagesEN from '../utils/translations/en/messages.json'
import messagesFR from '../utils/translations/fr/messages.json'
import productsEN from '../utils/translations/en/products.json'
import productsFR from '../utils/translations/fr/products.json'

const resources = {
    en: {
        translation: translationEN,
        errors: errorsEN,
        titles: titlesEN,
        messages: messagesEN,
        text: textEN,
        products: productsEN
    },
    fr: {
        translation: translationFR,
        errors: errorsFR,
        titles: titlesFR,
        messages: messagesFR,
        text: textFR,
        products: productsFR
    },
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng:'fr', //default language
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
